var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40498 12.0401C4.40498 11.6001 4.76498 11.2401 5.20498 11.2401L16.885 11.2401L13.265 7.60007C12.945 7.28007 12.945 6.78007 13.265 6.46007C13.425 6.30007 13.625 6.22008 13.825 6.22008C14.025 6.22008 14.245 6.30007 14.385 6.46007L19.365 11.4601C19.685 11.7801 19.685 12.2801 19.365 12.5801L14.385 17.5801C14.065 17.9001 13.565 17.9001 13.245 17.5801C12.925 17.2601 12.925 16.7601 13.245 16.4401L16.885 12.8401L5.20498 12.8401C4.76498 12.8401 4.40498 12.4801 4.40498 12.0401Z",
    fill: "#080A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow Right.8dcbeb48bd83b0592f0af3c5934a3fa1.svg";
export { ForwardRef as ReactComponent };